import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../_services/user.service';

@Component({
  selector: 'app-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.scss']
})
export class ForgotUsernameComponent implements OnInit {
  loading = false;
  error = '';
  sent = false;
  forgotUsernameForm: any;

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.forgotUsernameForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.forgotUsernameForm.get(fieldName);
    return field ? field.invalid && (field.dirty || field.touched) : false;
  }

  getFieldError(fieldName: string): string {
    const field = this.forgotUsernameForm.get(fieldName);
    if (!field || !field.errors) return '';
    if (field.errors['required']) return 'Email address is required';
    if (field.errors['email']) return 'Please enter a valid email address';
    return 'Invalid input';
  }

  onSubmit(): void {
    if (this.forgotUsernameForm.invalid) {
      this.forgotUsernameForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.error = '';

    this.userService.forgotUsername(this.forgotUsernameForm.get('email').value).subscribe({
      next: () => {
        this.loading = false;
        this.sent = true;
      },
      error: () => {
        this.loading = false;
        this.error = 'Something went wrong. Please try again later.';
      }
    });
  }

  clearError(): void {
    this.error = '';
  }
}
